import apiRoutes from './api.routes';
import ModelService from './model.service';

const ProjectCategoryService = new ModelService(apiRoutes.projectsCategories, '/project-category', 'content');

ProjectCategoryService.getImage = (filename, w = false, h = false, c = false) => ProjectCategoryService.getFilePathByDir('/uploads/use-cases', filename, w, h, c);

/** Types */

ProjectCategoryService.TYPE_PLATFORM = 1;
ProjectCategoryService.TYPE_TAG = 2;
ProjectCategoryService.TYPE_HASHTAG = 3;

ProjectCategoryService.getTypeList = t => ({
  [ProjectCategoryService.TYPE_PLATFORM]: t('Platform'),
  [ProjectCategoryService.TYPE_TAG]: t('Tag'),
  [ProjectCategoryService.TYPE_HASHTAG]: t('HashTag'),
});

ProjectCategoryService.ICON_CHART= '/img/icons/grow-arrow.png';
ProjectCategoryService.ICON_STAR = '/img/icons/star.png';
ProjectCategoryService.ICON_TAG = '/img/icons/brackets.png';

ProjectCategoryService.getIconsList = t => ({
  [ProjectCategoryService.ICON_CHART]: t('Chart'),
  [ProjectCategoryService.ICON_STAR]: t('Star'),
  [ProjectCategoryService.ICON_TAG]: t('Brackets'),
});

ProjectCategoryService.getTypeOptions = t => ProjectCategoryService
  .prepareOptionsFromSimpleObject(ProjectCategoryService.getTypeList(t));

ProjectCategoryService.getTypeTitle = (status, t) => {
  const label = ProjectCategoryService.getTypeList(t)[status];
  return label || '-';
};

ProjectCategoryService.getIconTitle = (item, t) => {
  const label = ProjectCategoryService.getIconsList(t)[item];
  return label || '-';
};

ProjectCategoryService.getIconsOptions = t => ProjectCategoryService
  .prepareOptionsFromSimpleObject(ProjectCategoryService.getIconsList(t));

ProjectCategoryService.POSITION_HOME = 1;

ProjectCategoryService.getPositionList = t => ({
  [ProjectCategoryService.POSITION_HOME]: t('Home page'),
});

ProjectCategoryService.getPositionOptions = t => ProjectCategoryService
  .prepareOptionsFromSimpleObject(ProjectCategoryService.getPositionList(t));

ProjectCategoryService.getPositionTitle = (status, t) => {
  const label = ProjectCategoryService.getPositionList(t)[status];
  return label || '-';
};

export default ProjectCategoryService;



// WEBPACK FOOTER //
// ./src/services/projectCategory.service.js